import React, { useEffect, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";

import { IoMdSearch } from "react-icons/io";
import { Button } from "@material-ui/core";
import Result from "./components/Result";

const useStyles = makeStyles((theme: Theme) => ({
  searchBar: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    textAlign: "center",
    display: "flex",
    color: "#868686",
    border: "2px #868686 solid",
    alignContent: "center",
    alignItems: "center",
    borderRadius: 4,
    justifyContent: "space-between",
    padding: 0,
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
      marginTop: 10,
    },
    '&::placeholder': {
      color: '#868686', 
    },
  },
  searchBarInput: {
    border: "none",
    width: '100%',
    fontSize: theme.typography.pxToRem(16),
    minWidth: "18vw",
    height: 47,
    outline: 0,
    margin: 0,
    '&:focus': {
      boxShadow: '0 0 0 2px #FFFFFF',
    },
  },
  btnSearch: {
    background: "#FFF",
    height: 47,
    margin: 0,
    padding: 0,
    width: 47, 
    borderRadius: "0", 
    "&:hover": {
      background: "#FFF",
      opacity: 0.8,
    },
  },
  icon: {
    color: "#868686",
    width: 24,
    height: 24,
  },
}));

export default function SearchServices(): JSX.Element {
  const classes = useStyles();
  const [textSearch, setTextSearch] = useState<string | undefined>();
  const [showModalResult, setShowModalResult] = useState<boolean>(false);

  const handleSubmit = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    if (textSearch) {
      setShowModalResult(true);
    }
  };

  useEffect(() => {
    if (!textSearch) {
      setShowModalResult(false);
    }
  }, [textSearch]);

  return (
    <>
      <form className={classes.searchBar} onSubmit={handleSubmit}>
        <Button className={classes.btnSearch} onClick={handleSubmit}>
          <IoMdSearch className={classes.icon} />
        </Button>
        <input
          type="text"
          aria-label="description"
          placeholder="Buscar..."
          className={classes.searchBarInput}
          id="searchBarInput"
          value={textSearch}
          onChange={(e) => {
            setShowModalResult(false);
            setTextSearch(e.target.value);
          }}
        />
      </form>
      {showModalResult && textSearch && (
        <Result
          show={showModalResult}
          setShow={setShowModalResult}
          termsForSearch={textSearch}
        />
      )}
    </>
  );
}
